.section h2 {
  color: var(--cxy-color-content-default);
  padding: var(--cxy-spacing-2) 0;
  font-size: var(--cxy-fontSize-xl);
  font-weight: var(--cxy-fontWeight-bold);
}
.section .sectionWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--cxy-spacing-4) 0;
}
.section .sectionWrapper h2 {
  padding: 0;
}
.section .sectionWrapper .clear {
  font-size: var(--cxy-fontSize-s);
  height: max-content;
}

.accordionContent {
  padding-top: var(--cxy-spacing-2);
}
